import '@/sections/contacts';
import '@/sections/first-screen';
import '@/sections/flats-promotion';
import '@/sections/location';
import '@/sections/main-screen';
import '@/components/flat';
import {
    initAbout,
    initAccordions,
    initAnimation,
    initCallbackPopup,
    initFinishingTooltip,
    initForm,
    initFullVideo,
    initHeader,
    initMatchHeight,
    initMobileMenu,
    initPopup,
    initPostMessagePopup,
    initShare,
    initTabs,
    initYoutubePlayer,
    lazyLoadElements,
    stepBack
} from './common';

import Observer from './observer';

const observer = new Observer();

// Поведение шапки
const headerWrap = document.querySelector('.j-header');

if (headerWrap) {
    initHeader(headerWrap);
}

// Поведение меню
const burgerMenuSelector = document.querySelector('.j-burger');

if (burgerMenuSelector) {
    const headerWrapper = headerWrap || document.querySelector('header');

    if (headerWrapper) {
        initMobileMenu(burgerMenuSelector, headerWrapper);
    }
}

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));

if (anchors.length) {
    import(/* webpackChunkName: "scrollBy" */ '@/components/scrollBy')
        .then((module) => {
            const ScrollBy = module.default;

            const scrollBy = new ScrollBy();
            const activeClass = 'is-active';

            scrollBy.init({
                takeElements: [headerWrap],
                anchors
            });

            observer.subscribe('anchorChangeSection', (id) => {
                anchors.forEach((item) => {
                    const href = item.getAttribute('href');

                    item.classList.remove(activeClass);

                    if (href === id || href === `/${id}`) {
                        item.classList.add(activeClass);
                    }
                });
            });
        });
}

// Видео на первом экране
const fullIframes = Array.from(document.querySelectorAll('.j-first-screen__iframe'));

if (fullIframes.length) {
    fullIframes.forEach((fullIframe) => {
        initFullVideo(fullIframe);
    });
}

// Видео youtube на первом экране (инициализация плеера через API youtube)
const youtubeFrame = document.querySelector('.j-first-screen__youtube');

if (youtubeFrame) {
    initFullVideo(youtubeFrame);
    initYoutubePlayer(youtubeFrame);
}

// Скролл на высоту главного экрана
const firstScreenScrollElement = document.querySelector('.j-first-screen-scroll');

if (firstScreenScrollElement) {
    import(/* webpackChunkName: "first-screen-scroll" */ '@/components/first-screen-scroll')
        .then((module) => {
            const FirstScreenScroll = module.default;
            const scroll = new FirstScreenScroll({
                element        : firstScreenScrollElement,
                wrapperSelector: '.j-main-screen'
            });

            scroll.init();
        });
}

// Большой слайдер
const bigSliderWrappers = Array.from(document.querySelectorAll('.j-slider'));

if (bigSliderWrappers.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            bigSliderWrappers.forEach((bigSliderWrapper) => {
                const slider = new Slider();

                slider.init({
                    slider       : bigSliderWrapper,
                    dots         : false,
                    thumbnails   : false,
                    arrow        : true,
                    counter      : true,
                    arrowPosition: 'caption',
                    caption      : true,
                    modify       : 'big_slide',
                    infinityLoop : true,
                    controls     : true
                });

                const finishingTooltips = [...bigSliderWrapper.querySelectorAll('.j-finishing-button')];

                finishingTooltips.forEach((element) => {
                    element.addEventListener('mouseenter', () => {
                        initFinishingTooltip(element);
                    });
                });

                // observer.publish('lazyLoad:refresh', bigSliderWrapper);
            });
        });
}

// Подключение мелких галерей
const slidersMini = Array.from(document.querySelectorAll('.j-slider-mini'));

if (slidersMini.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            slidersMini.forEach((item) => {
                const sliderMini = new Slider();

                sliderMini.init({
                    slider       : item,
                    dots         : false,
                    thumbnails   : false,
                    caption      : true,
                    arrow        : true,
                    counter      : true,
                    arrowPosition: 'caption',
                    modify       : 'mini_slide',
                    infinityLoop : true
                });

                // observer.publish('lazyLoad:refresh', item);
            });
        });
}

// Галерея подборок квартир на главной
const slidersCompilation = Array.from(document.querySelectorAll('.j-flats-compilation-slider'));

if (slidersCompilation.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            slidersCompilation.forEach((item) => {
                const sliderCompilation = new Slider();

                sliderCompilation.init({
                    slider      : item,
                    dots        : false,
                    thumbnails  : false,
                    arrow       : true,
                    counter     : false,
                    autoplay    : false,
                    slideVisible: 4,
                    slideCount  : 3,
                    responsive  : {
                        670 : 3,
                        1280: 4
                    }
                });

                // observer.publish('lazyLoad:refresh', item);
            });
        });
}

// Подключение галерей новостей
const slidersNews = [...document.querySelectorAll('.j-slider-news')];

if (slidersNews.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            slidersNews.forEach((item) => {
                const sliderNews = new Slider();

                sliderNews.init({
                    slider       : item,
                    dots         : false,
                    thumbnails   : false,
                    arrow        : true,
                    counter      : false,
                    arrowPosition: 'caption',
                    slideCount   : 3,
                    autoplay     : false,
                    slideVisible : 3,
                    innerModify  : 'j-animation__slider-row',
                    innerData    : 'data-items="320:3"',
                    responsive   : {
                        0   : 1 + (5 / 31),
                        670 : 2 + (5 / 15.5),
                        1280: 3
                    }
                });

                initAnimation({
                    blockSelector: '.j-animation__slider',
                    rowSelector  : '.j-animation__slider-row'
                });

                // observer.publish('lazyLoad:refresh', item);
            });
        });
}

// Галерея планировок в карточке квартиры
const flatSliderWrappers = Array.from(document.querySelectorAll('.j-slider-flat'));

if (flatSliderWrappers.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            flatSliderWrappers.forEach((flatSliderWrapper) => {
                const slider = new Slider();

                slider.init({
                    slider       : flatSliderWrapper,
                    dots         : false,
                    thumbnails   : false,
                    arrow        : true,
                    counter      : true,
                    arrowPosition: 'caption',
                    caption      : false,
                    infinityLoop : false,
                    controls     : true
                });

                // observer.publish('lazyLoad:refresh', flatSliderWrapper);
            });
        });
}

// Подключение мелких галерей
const flatBlockSliderWrappers = Array.from(document.querySelectorAll('.j-slider-flat-block'));

if (flatBlockSliderWrappers.length) {
    import(/* webpackChunkName: "slider" */ '@/components/slider')
        .then(({default: Slider}) => {
            flatBlockSliderWrappers.forEach((item) => {
                const flatBlockSlider = new Slider();

                flatBlockSlider.init({
                    slider      : item,
                    dots        : true,
                    thumbnails  : false,
                    caption     : false,
                    arrow       : false,
                    counter     : false,
                    infinityLoop: true
                });

                // observer.publish('lazyLoad:refresh', item);
            });
        });
}

/* Ленивая загрузка */
/* подключать после инициализации слайдеров */
const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

observer.subscribe('lazyLoad:refresh', (container) => {
    const secLazyElements = Array.from(container.querySelectorAll('[loading=lazy]'));

    lazyLoadElements(secLazyElements);
});

observer.subscribe('slider:ready', (object) => {
    const sliderLazyElements = Array.from(object['slider'].querySelectorAll('[loading=lazy]'));

    lazyLoadElements(sliderLazyElements);
});

// Плавный подскролл по якорям
const simpleAnchors = Array.from(document.querySelectorAll(`a[href^="#"]:not(.j-anchor)`));

if (simpleAnchors.length) {
    simpleAnchors.forEach((anchor) => {
        if (anchor.getAttribute('href').length === 1) {
            return;
        }

        const anchorBlock = document.querySelector(anchor.getAttribute('href'));

        if (anchorBlock) {
            anchor.addEventListener('click', (event) => {
                event.preventDefault();

                anchorBlock.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        }
    });
}

// Табы
const tabs = Array.from(document.querySelectorAll('.j-tabs-wrap'));

tabs.forEach((elem) => {
    initTabs(elem);
});

// Аккордеон
const accordions = Array.from(document.querySelectorAll('.j-accordion'));

if (accordions.length) {
    accordions.forEach((accordion) => {
        initAccordions(accordion);
    });
}

// Details Accordion
const details = document.querySelectorAll('.j-details');

if (details.length) {
    import(/* webpackChunkName: "details-accordion" */ '@/components/details')
        .then(({default: DetailsAccordion}) => {
            details.forEach((element) => {
                const accordion = new DetailsAccordion();

                accordion.init({
                    element
                });
            });
        });
}

// Прячущаяся навигация (меню без выборщиков)
const navigationWrappers = Array.from(document.querySelectorAll('.j-header__nav'));

if (navigationWrappers.length) {
    import(/* webpackChunkName: "navigation" */ '@/components/navigation')
        .then(({default: Navigation}) => {
            navigationWrappers.forEach((navigationWrapper) => {
                const navigation = new Navigation();

                navigation.init({
                    target           : navigationWrapper,
                    wrapper          : '.j-header__inner',
                    driveElements    : '.j-header__drive',
                    foldingNavigation: '.j-folding-navigation',
                    breaks           : {
                        min: 960,
                        max: 1600
                    }
                });
            });
        });
}

// Навигация с группировкой (меню с выборщиками)
const navigationGroupWrappers = Array.from(document.querySelectorAll('.j-group-navigation'));

navigationGroupWrappers.forEach((navigationGroupWrapper) => {
    import(/* webpackChunkName: "navigation-group" */ '@/components/navigation-group')
        .then(({default: NavigationGroup}) => {
            const navigationGroup = new NavigationGroup({
                navigation: navigationGroupWrapper
            });

            navigationGroup.init();
        });
});


// Формы
const formWrappers = Array.from(document.querySelectorAll('.j-form'));

if (formWrappers.length) {
    formWrappers.forEach((wrapper) => {
        initForm(wrapper);
    });
}

// Попапы
const popupSelectors = Array.from(document.querySelectorAll('.j-popup'));

if (popupSelectors.length) {
    initPopup(popupSelectors, {removeDelay: 300});
}

// Отдельный селектор для попапов обратных звонков
const popupFacadeLinks = Array.from(document.querySelectorAll('.j-popup-callback:not([data-init])'));

if (popupFacadeLinks.length) {
    initCallbackPopup(popupFacadeLinks);

    popupFacadeLinks.forEach((button) => {
        button.dataset.init = 'true';
    });
}

// Фиксирует высоту блоков
const matchHeightWrappers = Array.from(document.querySelectorAll('.j-match-height'));

matchHeightWrappers.forEach((matchHeightWrapper) => {
    initMatchHeight(matchHeightWrapper);
});

// Шаг назад
const stepBackSelector = document.querySelector('.j-back');

if (stepBackSelector) {
    stepBack(stepBackSelector);
}

// Шеринг
const shareElements = Array.from(document.querySelectorAll('.j-share'));

if (shareElements.length) {
    initShare(shareElements);
}

// Ипотечный калькулятор
const mortgageCalculator = document.querySelector('.j-mortgage-calculator');

if (mortgageCalculator) {
    import(/* webpackChunkName: "mortgage-calculator" */ '@/components/mortgage-calculator')
        .then((module) => {
            const MortgageCalculator = module.default;

            const calculator = new MortgageCalculator({
                wrapper: mortgageCalculator
            });

            calculator.init();
        });
}

// Мобильное меню
const mobileNavigation = document.querySelector('.j-navigation-mobile');

if (mobileNavigation) {
    import(/* webpackChunkName: "mobile-navigation" */ '@/components/navigation-mobile')
        .then((module) => {
            const MobileNavigation = module.default;

            const navigation = new MobileNavigation({
                element: mobileNavigation
            });

            navigation.init();
        });
}

// Анимация
initAnimation();

// j-visual-frame
const visualIframes = [...document.querySelectorAll('.j-visual-frame')];

if (visualIframes.length) {
    initPostMessagePopup();
}

// Уведомление об использовании cookies
const cookiesWrapper = document.querySelector('.j-cookies-notice');

if (cookiesWrapper) {
    import(/* webpackChunkName: "cookies-notice" */ '@/components/cookies-notice')
        .then(({default: CookiesNotice}) => {
            const cookiesNotice = new CookiesNotice({wrapper: cookiesWrapper});

            cookiesNotice.init();
        });
}

const aboutWrappers = [...document.querySelectorAll('.j-about__more')];

aboutWrappers.forEach((aboutWrapper) => {
    const options = {
        element: aboutWrapper
    };

    initAbout(options);
});

const finishingTooltips = [...document.querySelectorAll('.j-finishing-button')];

finishingTooltips.forEach((element) => {
    element.addEventListener('mouseenter', () => {
        initFinishingTooltip(element);
    });
});

const fromCTtoYA = () => {
    if (window.ct) {
        window.ct('modules', 'widgets', 'subscribeToEvent', [{
            object  : 'request',
            action  : 'create',
            callback: () => {
                window.ym(83623513, 'reachGoal', ' calltouch_form_submit');
            }}]);
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fromCTtoYA);
} else {
    fromCTtoYA();
}
